module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/pen-cba2a784ac4d3649fb1be33afeac6426.svg";